<template>
  <div class="cell">
    <van-tabs v-model="form.status" @change="change" swipeable>
      <van-tab title="待付款" name="unpaid"></van-tab>
      <van-tab title="已付款" name="paid"></van-tab>
      <van-tab title="不付款" name="refuse"></van-tab>
    </van-tabs>
    <van-cell center title="仅展示未审核" v-if="form.status === 'unpaid'">
      <template #right-icon>
        <van-switch v-model="approveChecked" size="24" />
      </template>
    </van-cell>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-for="(item, index) in list" :key="index">
        <div :style="{ 'display': (approveChecked && item.order_review_status) ? 'none' : 'block' }">
          <van-card :tag="item.status" :price="item.price / 100"
            :desc="'账号：' + item.dzy_account_id + '--' + item.inStockCount + '    时间：' + item.created_at"
            :title="item.title" :thumb="item.image_url" @click="openUrl(item.isbn, item.dzy_id)"
            :origin-price="item.all_amount">
            <div slot="footer">

              <van-button round size="normal" @click.stop="bindQRCode(item.code_url, item.id)">支付</van-button>
              <van-button round size="mini" @click.stop="payments(item.id)">重新支付</van-button>
              <van-button round size="mini" @click.stop="showSoldDialog = true, currentID = item.id"
                type="primary">设置出售价</van-button>
              <van-button round size="mini" @click.stop="duozhuayu(item.dzy_id)">查看多抓鱼</van-button>
              <van-button v-if="item.order_review_status === 0" round type="primary" size="mini"
                @click.stop="approve_order(item.id)">通过</van-button>
              <van-button v-if="item.status === 'unpaid'" round type="danger" size="mini"
                @click.stop="payid = item.id, showAction = true">不买</van-button>

            </div>
            <div slot="tags">
              <van-tag type="success" v-if="item.order_review_status === 1"> 审核通过</van-tag>
              <van-tag type="danger" v-else> 未审核</van-tag>
              <van-tag v-if="item.remark" type="warning"> 备注：{{ item.remark }} </van-tag>
              <van-tag v-if="item.all_amount"> 利润：{{ item.all_amount - item.price / 100 - (item.all_amount - 15) * 0.05
              }}
              </van-tag>
              <van-tag v-if="item.all_amount"> 利润率：{{ (item.all_amount - item.price /
                100 - (item.all_amount - 15) * 0.05) / item.all_amount * 100 }}% </van-tag>
              <van-tag> 类别数：{{ item.book_info.remark || '未知' }} </van-tag>
              <van-tag> 册数：{{ item.book_info.dzy_volumesCount || '未知' }} </van-tag>

              <span v-for="(item2, index) in item.flawReasons" :key="index">

                <van-tag type="danger" v-if="item2 === 'marks'"> 有划线或标注</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'lightly_dirty'"> 轻度污渍</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'lightly_mildew'"> 轻度发霉</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'lightly_breakage'"> 轻度破损</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'lightly_scratched'"> 轻度划破</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'lightly_folded'"> 折痕</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'lightly_deform'"> 变形</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'aging'"> 泛黄或褪色</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'cover_lost'"> 可拆卸外封套缺失</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'attachment_lost'"> 缺失附件</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'quality_issues'"> 印刷问题</van-tag>
                <van-tag type="danger" v-else-if="item2 === 'non-removable_labels'"> 附着胶带或标签</van-tag>
              </span>
              <div>重点监控：<van-switch v-if="item.status === 'unpaid'" v-model="item.is_important" size="16"
                  @click.stop="changeStatus(item.id, 0)" /></div>
              <div>要在首位：<van-switch v-if="item.status === 'unpaid'" v-model="item.first_rank" size="16"
                  @click.stop="changeStatus(item.id, 1)" /></div>
            </div>
          </van-card>
        </div>
      </div>
    </van-list>
    <van-action-sheet cancel-text="取消" close-on-click-action @cancel="showAction = false" v-model="showAction"
      :actions="actions" @select="onSelect" />
    <div v-show="showCode" class="code">
      <van-overlay :show="show">
        <div class="wrapper" @click.stop="hideCode">
          <div id="qrCode" ref="qrCodeDiv"></div>
          <van-button round type="primary" size="small" style="margin-top:20px"
            @click.stop="queryPayment(id)">检测</van-button>
        </div>
      </van-overlay>
    </div>
    <van-dialog v-model="showSoldDialog" title="设置出售价" show-cancel-button @confirm="setAllAmount">
      <van-field v-model="all_amount" label="出售总价" placeholder="请输入出售总价" />
      <div style="margin: 15px 10px;">
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;" @click="updateAllAmount(-5)">-5元</van-button>
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;" @click="updateAllAmount(-2)">-2元</van-button>
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;" @click="updateAllAmount(-1)">-1元</van-button>
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;" @click="updateAllAmount(1)">+1元</van-button>
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;" @click="updateAllAmount(2)">+2元</van-button>
      </div>
    </van-dialog>

  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  data () {
    return {
      id: '',
      payid: '',
      all_amount: 0,
      list: [],
      show: true,
      approveChecked: true,
      showSoldDialog: false,
      currentID: -1,
      loading: false,
      showAction: false,
      showCode: false,
      finished: false,
      checked: false,
      actions: [{ name: '库存过多', subname: '仓库书本较多待出货' }, { name: '性价比低', subname: '价格贵利润性价比不高' }, { name: '等待降价', subname: '等待降价再去购买' }, { name: '没利润', subname: '商品没什么利润' }, { name: '难周转', subname: '难周转，库存有一两本就行' }, { name: '太贵', subname: '商品价格太高，风险大,库存一两本就行' }, { name: '临时', subname: '临时不买当前的，稍后移出' }, { name: '移出购物车', subname: '移出购物车，没利润' }],
      form: {
        isbn: '',
        quality: '',
        status: 'unpaid',
        type: 0,
        page: 0,
        perPage: 20
      }
    }
  },
  computed: {
    currentPrice () {
      return this.$store.state.currentPrice
    }
  },
  watch: {
    currentPrice (newValue) {
      this.all_amount = newValue
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    updateAllAmount (price) {
      this.all_amount = parseFloat(this.all_amount) + price
    },
    async onSelect (item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.showAction = false
      console.log(item)
      const { data: res } = await this.$http.get('duozhuayu/pay/refuse?id=' + this.payid + '&not_buy_type=' + item.name + '&remark=' + item.subname)
      if (res.code === 200) {
        this.change()
      }
    },
    hideCode () {
      console.log('xxxxxxxxxxxxx')
      this.showCode = false
      this.$refs.qrCodeDiv.innerHTML = ''
    },
    bindQRCode: function (codeUrl, id) {
      this.id = id
      this.showCode = true
      new QRCode(this.$refs.qrCodeDiv, {
        text: codeUrl,
        width: 120,
        height: 120,
        colorDark: '#333333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L// 容错率，L/M/H
      })
    },

    openUrl (isbn, dzyId) {
      this.$router.push({
        path: '/book',
        query: {
          isbn: isbn,
          dzyid: dzyId
        }
      })
    },
    duozhuayu (dzyId) {
      window.open('https://www.duozhuayu.com/books/' + dzyId, '_blank')
    },
    async onLoad () {
      this.loading = true
      this.form.page = this.form.page + 1
      const url = 'duozhuayu/pay/list'
      const { data: res } = await this.$http.post(url, this.form)
      if (res.code === 200) {
        this.list = this.list.concat(res.data)
        if (res.data.length === 20) this.finished = false
        else this.finished = true
      } else {
        this.finished = true
      }
      this.loading = false
    },
    async queryPayment (id) {
      const { data: res } = await this.$http.get('duozhuayu/pay/queryPayment?id=' + id)
      if (res.code === 200) {
        this.hideCode()
        this.change()
      }
    },
    async approve_order (id) {
      const { data: res } = await this.$http.get('duozhuayu/pay/approve_order?id=' + id)
      if (res.code === 200) {
        this.change()
      }
    },
    async payments (id) {
      const { data: res } = await this.$http.get('duozhuayu/pay/payments?id=' + id)
      if (res.code === 200) {
        this.change()
      }
    },
    async setAllAmount () {
      const { data: res } = await this.$http.get('duozhuayu/pay/setAllAmount?id=' + this.currentID + '&all_amount=' + this.all_amount)
      if (res.code === 200) {
        this.change()
      }
    },
    async changeStatus (id, type) {
      const { data: res } = await this.$http.get('duozhuayu/pay/switch?id=' + id + '&type=' + type)
      if (res.code === 200) {
        // this.change()
      }
    },
    change () {
      this.form.page = 0
      if (this.form.status !== 'unpaid') this.approveChecked = false
      else this.approveChecked = true
      this.list = []
      this.onLoad()
    }
  }
}
</script>
<style lang="less" scoped>
.van-tag {
  margin-left: 5px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
